export default __webpack_public_path__ + "static/media/skippedmeal@3x.ba23bac6.jpg";